/**
 * @generated SignedSource<<f58dfe7e116e2bfd91bce334902e6044>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type BoardsTable$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly __typename: string;
      readonly boardId?: string | null | undefined;
      readonly container?: {
        readonly __typename: "SearchResultJiraBoardProjectContainer";
        readonly key: string;
        readonly name: string;
        readonly projectId: string;
      } | {
        readonly __typename: "SearchResultJiraBoardUserContainer";
        readonly name: string;
        readonly userAccountId: string;
      } | {
        // This will never be '%other', but we need some
        // value in case none of the concrete values match.
        readonly __typename: "%other";
      } | null | undefined;
      readonly favourite?: boolean;
      readonly iconUrl?: string | null | undefined;
      readonly title: string;
      readonly url: string;
    } | null | undefined;
  }>;
  readonly " $fragmentType": "BoardsTable";
};
export type BoardsTable$key = {
  readonly " $data"?: BoardsTable$data;
  readonly " $fragmentSpreads": FragmentRefs<"BoardsTable">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "BoardsTable",
  "selections": [
    {
      "concreteType": "SearchResultItemEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "kind": "ScalarField",
              "name": "title"
            },
            {
              "kind": "ScalarField",
              "name": "url"
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "boardId"
                },
                {
                  "kind": "ScalarField",
                  "name": "favourite"
                },
                {
                  "kind": "ScalarField",
                  "name": "iconUrl"
                },
                {
                  "kind": "LinkedField",
                  "name": "container",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "name": "projectId"
                        },
                        {
                          "alias": "key",
                          "kind": "ScalarField",
                          "name": "projectKey"
                        },
                        {
                          "alias": "name",
                          "kind": "ScalarField",
                          "name": "projectName"
                        }
                      ],
                      "type": "SearchResultJiraBoardProjectContainer"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "name": "userAccountId"
                        },
                        {
                          "alias": "name",
                          "kind": "ScalarField",
                          "name": "userName"
                        }
                      ],
                      "type": "SearchResultJiraBoardUserContainer"
                    }
                  ]
                }
              ],
              "type": "SearchResultJiraBoard"
            }
          ]
        }
      ]
    }
  ],
  "type": "SearchItemConnection"
};
})();

(node as any).hash = "cbc36fb46aaf7d10aa6cc41f00b25141";

export default node;
